import styled from "styled-components";

const ItemBoxStyled = styled.div`
background-color: white;
color: white;
border-radius: 20px;
border-color: aliceblue;
box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
padding: 3rem 5rem;

.title {
    font-size: 1rem;
    color: black;
}
`

export default ItemBoxStyled;
